import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "assessment.button.back": {
    id: "assessment.button.back",
    defaultMessage: "Back",
  },
  "assessment.button.save": {
    id: "assessment.button.save",
    defaultMessage: "Save",
  },
  "assessment.button.next": {
    id: "assessment.button.next",
    defaultMessage: "Next",
  },
  "assessment.menu.title": {
    id: "assessment.menu.title",
    defaultMessage: "Find my talent assessment",
  },
  "assessment.menu.progress": {
    id: "assessment.menu.progress",
    defaultMessage: "Progress",
  },
  "assessment.menu.questions": {
    id: "assessment.menu.questions",
    defaultMessage: "Questions",
  },
  "assessment.menu.responses": {
    id: "assessment.menu.responses",
    defaultMessage: "Responses",
  },
  "assessment.menu.save": {
    id: "assessment.menu.save",
    defaultMessage: "Save assessment",
  },
  "assessment.unfinished.title": {
    id: "assessment.unfinished.title",
    defaultMessage: "Unfinished assessment",
  },
  "assessment.unfinished.desc": {
    id: "assessment.unfinished.desc",
    defaultMessage:
      "You have an unfinished assessment. Do you want to continue taking the assessment or start the new one?",
  },
  "assessment.unfinished.discard": {
    id: "assessment.unfinished.discard",
    defaultMessage: "Start new",
  },
  "assessment.unfinished.continue": {
    id: "assessment.unfinished.continue",
    defaultMessage: "Continue",
  },

  "assessment.external-info.title": {
    id: "assessment.external-info.title",
    defaultMessage: "Do you already have the results?",
  },
  "assessment.external-info.desc": {
    id: "assessment.external-info.desc",
    defaultMessage:
      "Add your top talents in case you already passed such assessment as Gallup before.",
  },
  "assessment.external-info.add": {
    id: "assessment.external-info.add",
    defaultMessage: "Add results",
  },
  "assessment.external-info.continue": {
    id: "assessment.external-info.continue",
    defaultMessage: "Go to assessment",
  },

  "assessment.external.title": {
    id: "assessment.external.title",
    defaultMessage:
      "Add your top talents in case you already passed such assessment as Gallup before.",
  },
  "assessment.external.strength.placeholder": {
    id: "assessment.external.strength.placeholder",
    defaultMessage: "Type your talent",
  },
  "assessment.external.cancel": {
    id: "assessment.external.cancel",
    defaultMessage: "Cancel",
  },
  "assessment.external.save": {
    id: "assessment.external.save",
    defaultMessage: "Save",
  },
});
